import React from 'react';

const DiscountTag = ({ color = '#757575', width = 20, height = 20, ...rest }, ref) => {
  return (
    <svg
      {...rest}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}>
      <path
        d="M3.94024 13.4487C2.6523 12.1608 2.00832 11.5168 1.7687 10.6813C1.52908 9.84577 1.73387 8.95838 2.14343 7.1836L2.37962 6.16011C2.72419 4.66697 2.89648 3.9204 3.40771 3.40917C3.91894 2.89794 4.66551 2.72566 6.15864 2.38109L7.18213 2.1449C8.95692 1.73533 9.84431 1.53055 10.6798 1.77017C11.5153 2.00979 12.1593 2.65376 13.4472 3.94171L14.9719 5.4664C17.2128 7.70722 18.3332 8.82763 18.3332 10.2199C18.3332 11.6122 17.2128 12.7326 14.9719 14.9734C12.7311 17.2142 11.6107 18.3346 10.2184 18.3346C8.82617 18.3346 7.70576 17.2142 5.46494 14.9734L3.94024 13.4487Z"
        stroke={color}
        strokeWidth="1.25"
      />
      <circle
        cx="7.17245"
        cy="7.39844"
        r="1.66667"
        transform="rotate(-45 7.17245 7.39844)"
        stroke={color}
        strokeWidth="1.25"
      />
      <path d="M9.61837 15.418L15.4342 9.60193" stroke={color} strokeWidth="1.25" strokeLinecap="round" />
    </svg>
  );
};

export default React.forwardRef(DiscountTag);
